import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ProductExpandButton = styled(Button)(({ theme }) => ({
    color: theme.palette.primary.main,
    textDecoration: "underline",
    justifyContent: "flex-start",
    "&:hover": {
        background: "unset",
        textDecoration: "underline",
    },
}));
